// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__ocp1q","notes":"Notes_notes__5Udq4"};